const reportWithIncludeTaxes = ['staff-commission-sales', 'staff-sales-and-performance'];

export default reportWithIncludeTaxes;
